export const GET_EMAIL_VERIFICATION_STATUS = 'GET_EMAIL_VERIFICATION_STATUS'
export const GENERATE_EMAIL_OTP = 'GENERATE_EMAIL_OTP'
export const VERIFY_EMAIL_OTP = 'VERIFY_EMAIL_OTP'
export const GENERATE_MFA_OTP = 'GENERATE_MFA_OTP'
export const VERIFY_MFA_OTP = 'VERIFY_MFA_OTP'
